import classNames from "classnames";
import { useEffect, useState } from "react";
import "./appointmentStatus.css";
import { t } from "../../Utils/translate";

function AppointmentStatus({ label, labelType, customIcon, hcp }) {
  const [text, setText] = useState(null);
  const [icon, setIcon] = useState(null);
  const [stateType, setStateType] = useState(null);
  // console.log("labeltype",labelType)
  // console.log("label",label)

  useEffect(() => {
    if (label) {
      setText(label);
    }
    if (customIcon) {
      setIcon(customIcon);
    } else if (label) {
      let type = "";
      // switch (labelType) {
      switch (label) {
        case "COMPLETED":
        case "Started":
          setIcon(<i className="ri-check-double-fill" />);
          setStateType("appointment-status-green");
          break;
        case "Pending":
        case "Confirmed":
          setIcon(<i className="ri-timer-line" />);
          setStateType("appointment-status-green");
          break;

        case "Rejected":

        default:
          setIcon(" ");
          setIcon(<i className="ri-timer-line"></i>);
          setStateType("appointment-status-green");
      }
    }
  }, [label, customIcon, labelType]);

  if (stateType && icon) {
    return (
      <div className={classNames("appointment-status-container", stateType)}>
        <div>{icon ? icon : null}</div>
        <span className={"appointment-status"}>{t(text)}</span>
      </div>
    );
  }
}

export default AppointmentStatus;
